import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchClientReminder = async ({ clientId }) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_CLIENT_REMINDER}/${clientId}`
  );
  return response?.data;
};

export const postClientClientReminder = async ({ payload }) => {
  const response = await axiosInstance.post(
    Endpoints.POST_CLIENT_REMINDER,
    payload
  );
  return response?.data;
};
